module.exports = __webpack_public_path__ + "img/twitter.eaf5390f.svg";